import { format, parse } from 'date-fns';

export function isCaptureRecordInViewMonth(recordDate, selectedMonth) {
  return recordDate.startsWith(`${selectedMonth}-`);
}

export function formatCaptureRecordDateParams(recordDate) {
  const date = parse(recordDate, 'yyyy-MM-dd', new Date());
  return {
    year: format(date, 'yyyy'),
    month: format(date, 'M'),
    day: format(date, 'd'),
  };
}
